interface SignalLightProps {
  isBookedOut?: boolean | null;
  isAlmostBookedOut?: boolean | null;
  registrationDate?: string | Date | null;
  withText?: boolean;
}

export const SignalLight: React.FC<SignalLightProps> = ({
  isBookedOut,
  isAlmostBookedOut,
  registrationDate,
  withText,
}) => {
  const registrationClosed =
    !!registrationDate && new Date(registrationDate) < new Date();

  let color: 'red' | 'orange' | 'green';
  let label: string;

  if (isBookedOut) {
    color = 'red';
    label = 'Veranstaltung ist ausgebucht';
  } else if (registrationClosed) {
    color = 'red';
    label = 'Anmeldung geschlossen';
  } else if (isAlmostBookedOut) {
    color = 'orange';
    label = 'Veranstaltung ist fast ausgebucht';
  } else {
    color = 'green';
    label = 'Plätze verfügbar';
  }

  return (
    <div className="flex gap-2">
      <div
        className={`h-6 w-6 shrink-0 rounded-full ${color === 'red' ? 'bg-red-500' : ''} ${color === 'orange' ? 'bg-orange-500' : ''} ${color === 'green' ? 'bg-green-500' : ''}`}
      ></div>{' '}
      {withText && label}
    </div>
  );
};
